'use client';

export default function LoadingOverlay() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/80 z-[9999] backdrop-blur-sm">
      <div className="flex flex-col">
        <div className="flex flex-row space-x-4">
          <div className="w-12 h-12 rounded-full animate-spin border-2 border-solid border-white border-t-transparent" />
        </div>
      </div>
    </div>
  );
}
